import HotelCardStars from './HotelCardStars';

export default HotelCardStars;
